/* import __COLOCATED_TEMPLATE__ from './select-options-modal.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let SelectOptionsModal = (_class = class SelectOptionsModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "selectedValues", _descriptor2, this);
    _initializerDefineProperty(this, "defaultValues", _descriptor3, this);
    this.setInitialValues();
  }
  setInitialValues() {
    this.defaultValues = this.args.defaultValues ?? [];
    if (this.args.selectedValues.length > 0) {
      this.selectedValues = [...this.args.selectedValues];
      return;
    }
    this.selectedValues = [...this.defaultValues];
  }
  get singleSelectValue() {
    if (!this.args.isSingleSelect) {
      return '';
    }
    return this.selectedValues[0];
  }
  get isClearDisabled() {
    if (this.args.isSingleSelect) {
      return this.selectedValues[0] === this.defaultValues[0];
    }
    if (this.selectedValues.length !== this.defaultValues.length) {
      return false;
    }

    // create a map using new Map from selected values to check if all selected values are default values
    const selectedValuesMap = new Map(this.selectedValues.map(value => [value, true]));
    return this.defaultValues.every(value => selectedValuesMap.has(value));
  }
  get isSaveDisabled() {
    if (this.args.isSingleSelect) {
      return this.args.selectedValues[0] === this.selectedValues[0];
    }

    // TODO: If needed the logic to disable save button for multi select can be added here
    return false;
  }
  updateSingleSelectValues(selection) {
    this.selectedValues = [selection];
  }
  updateMultiSelectValues(selection) {
    if (this.selectedValues.includes(selection)) {
      this.selectedValues = this.selectedValues.filter(selectedValue => selectedValue !== selection);
      return;
    }
    this.selectedValues = [...this.selectedValues, selection];
  }
  handleSelectionChange(selection) {
    if (this.args.isSingleSelect) {
      this.updateSingleSelectValues(selection);
      return;
    }
    this.updateMultiSelectValues(selection);
  }
  onConfirm() {
    this.args.onConfirm(this.selectedValues);
  }
  onClear() {
    this.selectedValues = this.args.defaultValues ?? [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedValues", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "defaultValues", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateSingleSelectValues", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSingleSelectValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateMultiSelectValues", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateMultiSelectValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSelectionChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectionChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClear"), _class.prototype), _class);
export { SelectOptionsModal as default };